import { MAP_STEP_TO_COMPONENT } from './constants/steps';

export const getStepComponentFromKey = stepKey => {
  return MAP_STEP_TO_COMPONENT[stepKey];
};
